import { render, staticRenderFns } from "./PoweredByFooter.vue?vue&type=template&id=23e5a027&scoped=true"
import script from "./PoweredByFooter.vue?vue&type=script&lang=js"
export * from "./PoweredByFooter.vue?vue&type=script&lang=js"
import style0 from "./PoweredByFooter.vue?vue&type=style&index=0&id=23e5a027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5a027",
  null
  
)

export default component.exports